import astationCoupon from '../views/astation/coupon'

export default [
  {
    path: '/astation/coupon',
    name: 'astationCoupon',
    component: astationCoupon
  },
]


// WEBPACK FOOTER //
// ./src/router/astation.js